import React, {useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../actions/AdminActions";
import {loadAdminJobs} from "../helper functions/LoadAdminJobs";

export function EnquiryFullList() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const dispatch = useDispatch()
    let sort = useSelector(state => state.adminSortFull);
    let search = useSelector(state => state.adminSearchFull);
    const [loading, setLoading] = useState(true);

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>All Admin jobs</h1>
                    <p> A complete list of unapproved and approved admin jobs</p>
                </div>
                <hr/>

                <div className="dropdown">
                    <div className="dropdown-btn btn-secondary"> Sort by:</div>
                    <div className="dropdown-content">
                        <a onClick={sort => {
                            dispatch(actions.SortNew("ALL"))
                        }}>Newest First </a>
                        <a onClick={sort => dispatch(actions.SortOld("ALL"))}>Oldest First</a>
                        <a onClick={sort => dispatch(actions.SortAtoZ("ALL"))}> A-Z </a>
                    </div>
                </div>

                <div className="search">
                    <input id="search-input" type="text" className="search-box"
                           placeholder="Which job are you looking for?"/>
                    <button className="search-btn btn-secondary btn"
                            onClick={search => dispatch(actions.fullSearch(document.getElementById("search-input").value, "UNAPPROVED"))}> 🔍
                    </button>
                </div>

                <div className="page-break"></div>
                <br/>

                <div>
                    {loadAdminJobs(sort, search)}
                </div>

                <div className="page-break"></div>
            </AuthenticatedTemplate>
        </div>
    );
}
